import React from 'react';
import InfoCard from 'gui/pages/mainRouter/pages/ad/components/commons/infoCard/InfoCard';
import fill from 'fill-range';

interface IFirstPageProps {
}

const FirstStage = (props: IFirstPageProps) => (fill(0, 1)
    .map(i => <InfoCard defaultExpanded={i == 0 ? true : window.innerWidth >= 768} key={i} loading={true}/>)
);

FirstStage.defaultProps = {};

export default React.memo(FirstStage);
